﻿/**
 * GlobalTooltip
 * Displays native popover tooltips anchored to trigger elements.
 * Works with dynamically created elements via event delegation.
 * Mobile: tap to open, tap outside or on trigger again to close.
 * @package Shared
 */
export class GlobalTooltip {
  constructor() {
    if (GlobalTooltip._initialized) return;
    GlobalTooltip._initialized = true;

    if (!document.getElementById('global-tooltip')) {
      const tooltipDiv = document.createElement('div');
      tooltipDiv.id = 'global-tooltip';
      tooltipDiv.setAttribute('role', 'tooltip');
      tooltipDiv.popover = 'manual';
      document.body.appendChild(tooltipDiv);
    }
    this._tooltipElement = document.getElementById('global-tooltip');
    this._activeTrigger = null;

    document.body.addEventListener(
      'mouseenter',
      (e) => {
        const trigger = e.target.closest('[data-global-tooltip]');
        if (trigger) this._show(trigger);
      },
      true,
    );

    document.body.addEventListener(
      'mouseleave',
      (e) => {
        const trigger = e.target.closest('[data-global-tooltip]');
        if (trigger) this._hide();
      },
      true,
    );

    document.body.addEventListener(
      'focusin',
      (e) => {
        const trigger = e.target.closest('[data-global-tooltip]');
        if (trigger) this._show(trigger);
      },
      true,
    );

    document.body.addEventListener(
      'focusout',
      (e) => {
        const trigger = e.target.closest('[data-global-tooltip]');
        if (trigger) this._hide();
      },
      true,
    );

    document.body.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this._activeTrigger) {
        this._hide();
      }
    });

    document.body.addEventListener(
      'touchend',
      (e) => {
        const trigger = e.target.closest('[data-global-tooltip]');

        if (trigger) {
          e.preventDefault();
          if (this._activeTrigger === trigger) {
            this._hide();
          } else {
            this._show(trigger);
          }
          return;
        }

        if (this._activeTrigger) {
          this._hide();
        }
      },
      { passive: false },
    );
  }

  _show(trigger) {
    this._tooltipElement.textContent = trigger.getAttribute('data-global-tooltip');
    trigger.style.anchorName = '--active-tooltip-anchor';
    trigger.setAttribute('aria-describedby', 'global-tooltip');
    this._tooltipElement.style.positionAnchor = '--active-tooltip-anchor';
    this._activeTrigger = trigger;
    this._tooltipElement.showPopover();
  }

  _hide() {
    this._tooltipElement.hidePopover();
    if (this._activeTrigger) {
      this._activeTrigger.style.anchorName = '';
      this._activeTrigger.removeAttribute('aria-describedby');
      this._activeTrigger = null;
    }
  }
}
